import { render, staticRenderFns } from "./RoomCard.vue?vue&type=template&id=2597b87c&scoped=true&"
import script from "./RoomCard.vue?vue&type=script&lang=js&"
export * from "./RoomCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597b87c",
  null
  
)

export default component.exports